import React from "react";

const Callout = ({ title }) => (
  <section className="bg-tertiary c-primary pa br">
    <h1 className="ff-header" dangerouslySetInnerHTML={{ __html: title }} />
  </section>
);

export default Callout;
